<template>
  <div class="index-history">
    <div
      v-for="history in histories"
      :key="history.id"
      class="history-detail"
    >
      <router-link
        v-if="history.ambulance_type ==='急救车'"
        :to="{ path: '/showPatient/' + history.id }"
        active-class=""
      >
        <el-row>
          <el-col :span="1">
            时间:
          </el-col>
          <el-col :offset="1" :span="4">
            {{ history.formatTime }} -
          </el-col>
          <el-col :span="9">
            {{ history.done_time }}-
            {{ history.carName }}({{ carObject[history.ambulanceId] }})
          </el-col>
          <el-col :span="2">
            {{ history.age }}
            <span v-if="history.age">岁</span> &nbsp;
            &nbsp;
          </el-col>
          <el-col :span="2">
            {{ history.gender }}
            <span v-if="history.gender">性</span> &nbsp;
            &nbsp;
          </el-col>
          <el-col :span="4" class="main-complaint">
            主诉：{{
              history.mainComplaint
            }}
          </el-col>
        </el-row>
      </router-link>
      <router-link
        v-else
        :to="{ path: '/showPatientSmart/' + history.id }"
        active-class=""
      >
        <el-row>
          <el-col :span="1">
            时间:
          </el-col>
          <el-col :offset="1" :span="4">
            {{ history.formatTime }} -
          </el-col>
          <el-col :span="9">
            {{ history.done_time }}-
            {{ history.carName }}
          </el-col>
          <el-col :span="2">
            {{ history.ambulance_type }}
          </el-col>
        </el-row>
      </router-link>
    </div>
    <el-row
      v-if="hasNext"
      class="show-next"
    >
      <el-col
        :span="24"
        @click="loadMore"
      >
        加载更多
      </el-col>
    </el-row>
    <div v-show="!Object.keys(histories).length" class="no-message">
      暂无数据
    </div>
  </div>
</template>

<script>
import { getPatientsInfo } from "@api/hospitalList";
import { showWindowMessage } from "@utils/notification";
import { mapState } from "vuex";

export default {
  name: "IndexHistory",
  data() {
    return {
      histories: [],
      hasNext: 0, // 有没有下一页的数据
      form: {
        page: 0,
        number: 10
      }, // 查询病例历史数据的表单
    };
  },
  computed: {
    ...mapState({
      ambulanceLists: "ambulanceLists",
      carPlate: "carPlate",
      carObject: "carObject"
    }),
  },
  mounted() {
    this.loadMore();
  },
  methods: {
    /*
    * 加载更多的历史记录
    * */
    async loadMore() {
      const { page } = this.form;
      this.form.page = page + 1;
      if (page === 4) {
        await this.$router.push("/isShowManageCase/?category=manage&selected=isShowManageCase");
        return;
      }
      const { code, data, next, msg } = await getPatientsInfo(this.form);
      if (code !== 200) {
        showWindowMessage(3, msg, this);
        return;
      }
      this.hasNext = next;
      data.forEach(patient => {
        patient.carName = this.carPlate[patient.ambulanceId] || "未知急救车";
      });
      this.histories = this.histories.concat(data);
    },
  }
};
</script>

<style scoped lang="scss">
.no-message {
  text-align: center;
  margin-top: 135px;
}

.el-row {
  line-height: 50px;
  height: 50px;
  margin-left: 30px;

}

.history-detail {
  height: 50px;
  border: 2px solid #F0F5F7;
  margin-top: -2px;

  a {
    text-decoration: none;
    font-size: 16px;
    font-weight: 400;
    color: #666666;
  }

  .main-complaint {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.show-next {
  font-size: 16px;
  color: #666666;
  text-align: center;
  cursor: pointer;
}

.index-history {
  min-width: 910px;
}
</style>
